/* istanbul ignore file */
import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import '../styles/header.css';
import '../components.css';
import { closeView } from '../../utils/call-my-jio';
import leftArrow from '../../images/ic_back.svg';
import BackArrow from "../../images/back-arrow-white.svg";
import jioTogetherIcon from '../../images/logo_jiotogether.svg';
import {
  parseQueryString, goesBack, isMobileDevice
} from '../../utils/utils';
import LanguageButton from './LanguageButton';
import { useIsDesktop, useIsTablet } from '../../hooks/breakpoints';
import { ess } from '../OnBoarding/ess';
import { useAppState } from '../../contexts/appState';
import Logo from "../../images/JioHealthLogo.svg"

const styles = {
  headerView: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr 1fr',
    gridTemplateRows: '1fr',
    flexDirection: 'row',
    fontSize: '16px',
    width: '100%',
    position: 'fixed',
    height: '3.5rem',
    backgroundColor: '#1ECCB0',
    alignItems: 'center',
    zIndex: '901',
    borderBottom: '1px solid #CCC',
    // boxShadow: '0px 3px 5px #CCC'
  },
  headerViewTab: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
    flexDirection: 'row',
    fontSize: '16px',
    position: 'fixed',
    height: ' 4.5rem',
    width: '100%',
    backgroundColor: '#1ECCB0',
    alignItems: 'center',
    zIndex: '901',
    // borderRadius: '0em 0em  1.25em  1.25em',
    paddingLeft: '3.125em',
    paddingRight: '3.125em'
  },
  headerViewDesktop: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
    flexDirection: 'row',
    fontSize: '16px',
    position: 'fixed',
    height: '4.5rem',
    width: '100%',
    backgroundColor: '#1ECCB0',
    alignItems: 'center',
    zIndex: '902',
    //borderRadius: '0em 0em  1.25em  1.25em',
    borderRadius: '0em',
    // paddingLeft: '5em',
    paddingLeft: '0',
    paddingRight: '5em',
    // boxShadow: '0px 3px 6px #00000033',
    opacity: '1'
  },
  jioTogetherIcon: {
    height: '3.125em',
  },
  headerTitleDesktop: {
    display: 'none'
  },
  languageButtonMob: {
    marginRight: '1em'
  }
};
const BackButton = () => {
  const location = useLocation();
  const { goBack, push } = useHistory();

  const onBackClick = useCallback(() => {
    if (location.pathname === '/') {
      isMobileDevice() ? closeView() : push('/');
    } else if (location.pathname === '/create-profile/' || location.pathname === '/create-profile/error') {
      push('/');
    } else {
      goesBack(true);
      goBack();
    }
  }, [goBack, location.pathname, push]);

  if (parseQueryString().back === 'no') return null;

  return (
    <button
      style={{
        background: 'none',
        border: 0,
        marginRight: "1rem",
        cursor: 'pointer',
        outline: 'none',
        width: "2.5rem",
        height: "2.5rem"
      }}
      onClick={onBackClick}
    >
      <img
        src={BackArrow}
        width="2rem"
        height="2rem"
        alt=""
        style={{
          width: "2rem",
          height: "2rem",
          marginRight: "1rem",
        }}
      />
    </button>
  );
};

const hideHeader = () => {
  const currentPath = window.location.pathname.split('/')[2];
  return (currentPath === 'status');
};
const openMenu = (dispatch) => {
  dispatch({ type: 'UPDATE_MENUDRAWER_STATUS', menuDrawerStatus: true })
}
export default ({ shouldHide }) => {
  const [{ menu, hideHamburger }, dispatch] = useAppState()
  const isDesktop = useIsDesktop();
  const isTablet = useIsTablet();
  const history = useHistory();

  const goHome = () => {
    ess().isFromEss ? window.close() : history.push('/');
  };

  const RenderMobile = () => {
    const location = useLocation();
    console.log("location: ", location)
    const isBackButtonReq = location.pathname.length > 1;
    return (
      (shouldHide || hideHeader()) ? (<div style={{ display: 'none' }} />) : (
        <div>
          <div style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            fontSize: "16px",
            width: "100%",
            position: "fixed",
            height: "3.5rem",
            backgroundColor: "rgb(30, 204, 176)",
            alignItems: "center",
            zIndex: "901",
            /* border-bottom: 1px solid rgb(204, 204, 204); */
            margin: "0rem 0rem"
          }}>
            {/* {(history.location.pathname !== '/' && menu) && (
            <>
              {hideHamburger ?
                <>
                  <span></span>
                </>
                :
                <button className="logo-btn" style={{ marginLeft: "1rem" }} onClick={() => openMenu(dispatch)}>
                  <img src='/icons/menu.svg' />
                </button>
              }
              <img src="/icons/jioHH.svg" alt="Jio Health Hub" height="38" />
              {window.location.pathname.indexOf('workflow') > 0 ?
                <LanguageButton />
                :
                <></>
              }
            </>
          )} */}
            <div
              style={{
                border: 0,
                outline: 'none',
                textAlign: 'left',
                marginLeft: '2.5%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            // onClick={goHome}
            >

              {isBackButtonReq ? <BackButton /> : <img src={Logo} style={{ width: '40px', height: '40px', marginRight: '12px' }} alt="jhh logo" />}
              <div style={{ color: '#08332C', fontSize: '16px', fontFamily: 'JioType-Bold' }}>JioHealthHub</div>
            </div>

            {window.location.pathname.indexOf('workflow') > 0 ?
              <LanguageButton />
              :
              <></>}
          </div>
        </div>
      )
    );
  }

  const renderDesktop = () => (
    (shouldHide || hideHeader()) ? (<div style={{ display: 'none' }} />) : (
      <div>
        <div style={isTablet ? styles.headerViewTab : styles.headerViewDesktop}>
          <div
            style={{
              border: 0,
              outline: 'none',
              textAlign: 'left',
              marginLeft: '27%',
              display: 'flex',
              alignItems: 'center'
            }}
          // onClick={goHome}
          >

            <img src={Logo} style={{ width: '40px', height: '40px', marginRight: '12px' }} alt="jhh logo" />
            <div style={{ color: '#08332C', fontSize: '16px', fontFamily: 'JioType-Bold' }}>JioHealthHub</div>
          </div>

          {window.location.pathname.indexOf('workflow') > 0 ?
            <LanguageButton />
            :
            <></>}
        </div>
      </div>
    )
  );
  return (
    <>{(isDesktop || isTablet) ? renderDesktop() : RenderMobile()}</>

  );
};

